// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cd77f13","609":"d7d822b0","625":"f5641c1a","649":"54893cbb","652":"2c36b345","674":"af54d309","863":"2a11d5d9","872":"2c7e1b8e","900":"86e14a95"}[chunkId] + ".chunk.js";
};